module.exports = __webpack_public_path__ + "static/media/8_Severe.482ca85f.svg";